import axios from "axios";
import { Controller } from "@hotwired/stimulus";
import InputMask from "inputmask";

export default class extends Controller {
  connect() {
    this.maskBsbInput();
  }

  saveBankAccountDirectDebit(event) {
    preventDefaultAndStopPropagation(event);

    const form = $(".bank-account-form");
    if (validateBankAccountForm(form)) {
      showRequestProcessingModal();

      const url = this.data.get("url");
      const redirectUrl = this.data.get("redirectUrl");
      const submitMethod = this.data.get("submitMethod");

      axios({
        method: submitMethod,
        url: url,
        data: form.serialize()
      })
      .then(response => {
        hideRequestProcessingModal();
        bootbox.alert({
          title: formatBootboxTitle(response.data.success),
          className: response.data.success ? "success-modal" : "failure-modal",
          message: "Your bank account direct debit has been successfully set up.",
          callback: function () {
            window.location = redirectUrl;
          },
          closeButton: false
        });
      })
      .catch(error => {
        bootbox.alert({
          title: formatBootboxTitle(false),
          className: "failure-modal",
          message: "There is an error while processing your request, please make sure you entered correct details.",
          callback: function () {
            window.location = redirectUrl;
          },
          closeButton: false
        });
      });
    }
  }

  maskBsbInput() {
    var selector = document.querySelector(".bank-account-bsb");
    var im = new Inputmask("999-999");
    im.mask(selector);
  }
}
